// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"6f9ad513","252":"519b4255","956":"c0288c7e"}[chunkId] + ".chunk.js";
};